import type { ReactNode } from "react";
import { type BuiltTile, BuiltTiles, ProblemScene, type RoleTile, RoleTiles } from "./pitch";
import "./landing-top.css";

/**
 * Landing sections 2 to 4 in the pitch form (#2337): one plain title,
 * one drawing from the kit, almost no body copy. The hospital stays
 * anonymous on the public site (founder answer, 15 Oct 2026).
 */

const BUILT: BuiltTile[] = [
  {
    label: "Today",
    title: "Live in production",
    body: "Live in production at a hospital department in Singapore.",
    icons: ["check"],
  },
  {
    label: "October 2026",
    title: "Every seat filled",
    body: "Every on-call seat filled every night.",
    icons: ["record"],
    tone: "accent",
  },
  {
    label: "Every day",
    title: "Phone app and Telegram",
    body: "Members on the phone app and in Telegram.",
    icons: ["member", "chat"],
  },
];

const ROLES: RoleTile[] = [
  { icon: "supervisor", title: "Team lead" },
  { icon: "officer", title: "Senior member" },
  { icon: "team", title: "Team member" },
  { icon: "coordinator", title: "Coordinator" },
];

const PILLS = ["Rest after a night", "Call limits", "Leave", "Skills", "Standby", "Fair load"];

function LandingBlock({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: ReactNode;
}) {
  return (
    <section id={id} className="pt-landing-section" aria-labelledby={`${id}-title`}>
      <h2 id={`${id}-title`} className="pt-landing-title">
        {title}
      </h2>
      {children}
    </section>
  );
}

export function LandingTop() {
  return (
    <>
      <LandingBlock id="built-so-far" title="What we built so far">
        <BuiltTiles tiles={BUILT} />
      </LandingBlock>
      <LandingBlock id="shift-problem" title="The problem for a shift team">
        <RoleTiles roles={ROLES} pills={PILLS} />
      </LandingBlock>
      <LandingBlock id="rostering-wrong" title="Where rostering goes wrong">
        <ProblemScene />
      </LandingBlock>
    </>
  );
}
